import * as React from "react";

/**
 * Контейнер для публичных auth-страниц: тёмный фон, glow-пятна,
 * декоративная сетка, центрированная карточка ≤ 460px.
 */
export function AuthShell({
  children,
  glow = "purple",
}: {
  children: React.ReactNode;
  glow?: "purple" | "amber" | "cyan";
}): JSX.Element {
  const secondGlow =
    glow === "amber" ? "rgba(245,158,11,0.18)" : "rgba(6,182,212,0.18)";
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background px-4 py-8">
      <div
        className="glow-blob"
        style={{ left: "-10%", top: "-10%", width: 600, height: 600, background: "rgba(139,92,246,0.18)" }}
      />
      <div
        className="glow-blob"
        style={{ right: "-10%", bottom: "-10%", width: 500, height: 500, background: secondGlow }}
      />
      {/* decorative grid */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(139,92,246,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.05) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 70%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 70%)",
        }}
      />
      <div className="relative z-10 w-full max-w-[460px]">
        <div className="mb-6 flex items-center justify-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-primary text-base font-bold text-white shadow-glow-purple">
            SC
          </div>
          <div className="leading-tight">
            <div className="text-lg font-bold text-white">
              Semantic<span className="text-purple">.</span>Core
            </div>
            <div className="text-[11px] uppercase tracking-wider text-muted-foreground">
              конвейер семантики
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
